import { Box, customUseEffect, SearchIcon, TextField, useMemo, useRef, useState } from "@common";
const CommonSearch = ({ rows = [], searchFields = [], onFilter, onChange }) => {
    const [value, setValue] = useState("");
    const [focused, setFocused] = useState(false);
    const inputRef = useRef(null);

    const filteredRows = useMemo(() => {
        if (!value) return rows;

        const search = value.toLowerCase();

        return rows.filter((row) =>
            searchFields.some((field) => {
                const keys = field.split(".");
                let fieldValue = row;

                for (let key of keys) {
                    fieldValue = fieldValue?.[key];
                }

                return String(fieldValue || "")
                    .toLowerCase()
                    .includes(search);
            })
        );
    }, [value, rows, searchFields]);

    // send filtered data back to parent
    customUseEffect(() => {
        onFilter(filteredRows);
        // this one updated because this uesEffect it was calling mutliptle times
    }, [value]);

    return (
        <Box sx={{ position: "relative" }}>
            <TextField
                inputRef={inputRef}
                fullWidth
                size="small"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                onFocus={() => setFocused(true)}
                onBlur={() => !value && setFocused(false)}
                variant="outlined"
                sx={{
                    "& .MuiOutlinedInput-root": {
                        borderRadius: "2rem",
                        width: { xs: "15rem", sm: "15rem", md: "13rem", lg: "15rem" },
                        backgroundColor: "#fafafa",
                        paddingLeft: "1.5rem",
                        height: "2rem",
                        paddingTop: "0px",
                        // paddingLeft:""
                    },
                }}
            />

            {!focused && !value && (
                <Box
                    onClick={() => {
                        setFocused(true);
                        inputRef.current?.focus();
                    }}
                    sx={{
                        position: "absolute",
                        inset: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: { xs: "15rem", sm: "15rem", md: "13rem", lg: "15rem" },
                        // gap: 1,
                        color: "#0005084e",
                        cursor: "text",
                        // hover effect stylings
                        "&:hover": {
                            border: "1px solid #0005084e",
                            backgroundColor: "#b5c0c74e",
                            borderRadius: "2rem",
                        },
                        "&:hover fieldset": {
                            borderColor: "#ffffff",
                        },

                        // focus effect
                        "&.Mui-focused": {
                            backgroundColor: "#ffffff",
                            boxShadow: "0 0 0 3px rgba(25,118,210,0.15)",
                        },
                        "&.Mui-focused fieldset": {
                            borderColor: "#1976d2 !important",
                            borderWidth: "1px",
                        },
                    }}
                >
                    <SearchIcon sx={{ color: "black !important" }} fontSize="small" />
                    <span style={{ color: "#000" }}>Search</span>
                </Box>
            )}

            {(focused || value) && (
                <SearchIcon
                    fontSize="small"
                    sx={{
                        position: "absolute",
                        left: 12,
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "black !important"
                    }}
                />
            )}
        </Box>
    );
};

export default CommonSearch;
